<div class="main-container">
    <div class="structure-container" *ngIf="structures.rows.length; else noProductsTemplate">
        @for (structure of structures.rows; let i = $index ;track i) {
        <div class="wrapper">
            <div class="checkbox">
                <mat-checkbox
                    [checked]="selectedStructureIds.has(structure.id)"
                    (click)="$event.stopPropagation()"
                    (change)="onCheckboxChange($event, structure.id)"
                    *ngIf="structure.status === structureStatus.Saved"
                ></mat-checkbox>
                <span [ngClass]="structure.status">{{ structure.status }}</span>
            </div>
            <div class="inner-wrapper" (click)="goToMyStuctureDesign(structure.id)">
                <img
                    class="structure-image"
                    [class]="'product-image-gradient' + ((i % 3) + 1)"
                    [src]="structure.imageurl"
                />
                <mat-icon class="actions-icon" (click)="openPropertiesDialog(structure); $event.stopPropagation()"
                    >settings</mat-icon
                >
            </div>
            <div class="structure-details">
                <h3 class="structure-name font-poppins">{{ structure.structureName }}</h3>
                <p class="date">Created on {{ structure.updatedAt | date: "dd MMM YYYY" }}</p>
            </div>
            <div class="button-container">
                <button
                    mat-flat-button
                    class="btn-primary-gradient pub-btn"
                    [disabled]="!isStructureSelected(structure.id)"
                    (click)="onPublish(structure.id, structure.status!)"
                >
                    <span>{{ "structure.button.publishBtn" | translate }}</span>
                    <mat-icon class="button-text" svgIcon="publish"></mat-icon>
                </button>
                <button
                    class="dlt-btn"
                    [disabled]="!isStructureSelected(structure.id)"
                    (click)="onDelete(structure.id, structure.status!)"
                >
                    <mat-icon svgIcon="delete"></mat-icon>
                </button>
            </div>
        </div>
        }
    </div>
    <div class="view-more-container" *ngIf="showViewMoreButton">
        <button class="view-btn" (click)="onViewMore()">
            {{ "structure.button.viewMoreBtn" | translate }}
        </button>
    </div>

    <ng-template #noProductsTemplate>
        <div class="empty-structure" *ngIf="!loadingStructure">
            <div class="image-container">
                <mat-icon svgIcon="structure" />
            </div>

            <div class="message">
                <h2 class="font-poppins">{{ "structure.noStructure.noStructureFound" | translate }}</h2>
                <p *ngIf="!structures.totalCount">{{ "structure.noStructure.noStructureFoundMessage" | translate }}</p>
                <button class="btn" (click)="goTodesigner()">
                    <mat-icon svgIcon="arrowleft"></mat-icon> {{ "structure.button.goToDesigner" | translate }}
                </button>
            </div>
        </div>

        <div class="no-str-bottom">
            <div class="common" (click)="goToBestSeller()">
                <div class="contents">
                    <div class="icon popular">
                        <mat-icon [svgIcon]="'fullstar'"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Popular Toys</p>
                        <span>Discover trending toys for kids</span>
                    </div>
                </div>
            </div>
            <div class="common" (click)="goToFeature()">
                <div class="contents">
                    <div class="icon offer">
                        <mat-icon svgIcon="offer"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Special Offers</p>
                        <span>Check out amazing deals</span>
                    </div>
                </div>
            </div>
            <div class="common" (click)="goToWishlist()">
                <div class="contents">
                    <div class="icon wish">
                        <mat-icon svgIcon="activewishlist"></mat-icon>
                    </div>
                    <div class="para">
                        <p class="font-poppins">Wishlist</p>
                        <span>Save toys for later</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
